module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABTElEQVQ4T6XTv6uCUBQH8G+IS4s4+gdEg4KCuAU5BA7NzrnY0ihN9i/0B+QgODhF0JIupg2tESSNrdUa0dRgaPQe8nz39d672/31uedczqllWZYBwPl8xmq1QrfbxX6/x263y5c/RrvdRqPRwHQ6hSRJaDabxV4tB06nEwzDgKZpME2TCLiui9lsBtu20Wq1noDv+zgejxgOh6VXv5tEUYQwDDEej5+A4zjF2X6//xaw2WyQ35lMJl+Bw+GA+XxeCcmyDFVVQQTy/0iSpBLgeR6iKJKBd3IgRrBerzEajSodXdcxGAx+juB6vVYC9XodFEWRgcvlgu12WwJYli1yfw1iCmmawvO8EsBxHCzLeg/49yf+CfhtKcdxjMVi8VnKeSf2ej10Oh0wDEMM4n6/IwiCom/yqix64dXOy+USt9uNCNA0DUVRIAhCce4BpOgI4Jj3P8kAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/order.png
// module id = qB1b
// module chunks = 1